const createUrlFromIds = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(data[d]));
    return ret.join('&');
}

export default createUrlFromIds